import NextImage, { type ImageProps as NextImageProps } from "next/image";
import { cn } from "../lib/utils";

export interface ImageProps extends NextImageProps {
  /** Hairline border in the scheme's border color. Off by default. */
  bordered?: boolean;
}

/**
 * Image — the design-system image. Wraps next/image; visual options (like the
 * border) are props here instead of classes at each call site.
 */
export function Image({
  bordered = false,
  className,
  alt,
  ...props
}: ImageProps) {
  return (
    <NextImage
      alt={alt}
      className={cn(bordered && "border-scheme-border border", className)}
      {...props}
    />
  );
}
